<template>
  <div class="input-filed--container">
    <!-- 検診日 -->
    <div class="input-field--content input-field--content__date">
      <label>{{ $t("yourPhysicalInformation.healthExamDate") }}</label>
      <input
        type="date"
        name="date"
        v-model="T"
        v-validate="'required|isFuture'"
        :class="{ invalid: errors.has('date') }"
        data-vv-as="検診日"
      />
      <div class="invalid" v-show="errors.has('date')">
        {{ errors.first("date") }}
      </div>
    </div>
    <!-- 健康状態 -->
    <div class="input-field--content input-field--content__select">
      <label>{{ $t("yourPhysicalInformation.condition") }}</label>
      <select
        name="condition"
        :label="$t('yourPhysicalInformation.condition')"
        v-model.number="DFAB_PTN_CD"
        v-validate="'required'"
        v-bind:class="{ 'form-control': true, error: errors.has('condition') }"
      >
        <option value="0">{{ $t("yourPhysicalInformation.healthy") }}</option>
        <option value="1">{{
          $t("yourPhysicalInformation.physicallyDisabled")
        }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.brainDisabled")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.visuallyImpaired")
        }}</option>
        <option value="4">{{
          $t("yourPhysicalInformation.hearingImpaired")
        }}</option>
        <option value="5">{{
          $t("yourPhysicalInformation.laguageDisabled")
        }}</option>
        <option value="6">{{
          $t("yourPhysicalInformation.intellectuallyDisabled")
        }}</option>
        <option value="7">{{
          $t("yourPhysicalInformation.mentalyDisabled")
        }}</option>
        <option value="9">{{
          $t("yourPhysicalInformation.otherDisabilities")
        }}</option>
      </select>
      <div class="invalid" v-show="errors.first('condition')">
        {{ $t("validation.requiredText") }}
      </div>
    </div>
    <!-- 胴回り -->
    <div class="input-field--content input-field--content__waist">
      <label for>{{ $t("yourPhysicalInformation.waistCircumference") }}</label>
      <input
        v-model.number="WAIST"
        v-validate="'required|between:0.0, 130.0'"
        min="0.0"
        max="130.0"
        name="waist"
        v-bind:class="{ 'form-control': true, error: errors.has('waist') }"
      />
      <div class="invalid" v-show="errors.has('waist')">
        {{ $t("validation.requiredText") }}
      </div>
    </div>
    <!-- BMI -->
    <div class="input-field--content input-field--content__bmi">
      <label for="bmi">BMI</label>
      <input
        v-model.number="BMI"
        v-validate="'required|between:0.0,999.0'"
        name="bmi"
        min="0.0"
        max="999.0"
        v-bind:class="{ 'form-control': true, error: errors.has('bmi') }"
      />
      <div class="invalid" v-show="errors.has('bmi')">
        {{ $t("validation.requiredText") }}
      </div>
    </div>
    <!-- 血圧 -->
    <div class="input-field--content input-field--content__bp">
      <label>{{ $t("yourPhysicalInformation.bloodPressure") }}</label>
      <input
        type="number"
        v-model.number="BP_HIGH"
        :placeholder="$t('notebook.top')"
        v-validate="'required|between:0.0,400.0'"
        name="bp-high"
        min="0.0"
        max="400.0"
        v-bind:class="{ 'form-control': true, error: errors.has('bp-high') }"
      />
      <input
        type="number"
        v-model.number="BP_LWST"
        :placeholder="$t('notebook.bottom')"
        v-validate="'required|between:0.0,250.0'"
        name="bp-lwst"
        min="0.0"
        max="250.0"
        v-bind:class="{ 'form-control': true, error: errors.has('bp-lwst') }"
      />
      <div
        class="invalid"
        v-show="errors.has('bp-high') || errors.has('bp-lwst')"
        align="center"
      >
        {{ $t("validation.requiredText") }}
      </div>
    </div>
    <!-- 体重 -->
    <div class="input-field--content input-field--content__weight">
      <label for>{{ $t("yourPhysicalInformation.Weight") }}</label>
      <input
        v-model.number="WEIGHT"
        name="weight"
        min="0.0"
        max="999.9"
        v-validate="'between:0.0, 999.9'"
      />
      <div class="invalid" v-show="errors.has('weight')" align="center">
        {{ $t("validation.between") }}
      </div>
    </div>
    <!-- 心電図 -->
    <div class="input-field--content input-field--content__select">
      <label>{{ $t("yourPhysicalInformation.Electrocardiography") }}</label>
      <select
        name="electrocardiography"
        :label="$t('yourPhysicalInformation.Electrocardiography')"
        v-model.number="ELECTROCARDIOGRAPHY"
      >
        <!--TODO 0始まりにする-->
        <option value="1">{{ $t("yourPhysicalInformation.NoInput") }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
    </div>
    <!-- 喀痰検査 -->
    <div class="input-field--content input-field--content__select">
      <label>{{ $t("yourPhysicalInformation.SputumExamination") }}</label>
      <select
        name="sputumExamination"
        :label="$t('yourPhysicalInformation.SputumExamination')"
        v-model.number="SPUTUM_EXAMINATION"
      >
        <!--TODO 0始まりにする-->
        <option value="1">{{ $t("yourPhysicalInformation.NoInput") }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
    </div>

    <!-- 聴力 -->
    <heading
      :title="$t('yourPhysicalInformation.HearingTitle')"
      class="title-adjust"
    />
    <div class="input-field--content">
      <label>1000Hz</label>
      <select name="hearing-low-left" v-model.number="HEARING_LOW_LEFT">
        <option value="1">{{
          $t("yourPhysicalInformation.HearingLeft")
        }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
      <select name="hearing-low-right" v-model.number="HEARING_LOW_RIGHT">
        <option value="1">{{
          $t("yourPhysicalInformation.HearingRight")
        }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
    </div>
    <div class="input-field--content">
      <label>4000Hz</label>
      <select name="hearing-high-left" v-model.number="HEARING_HIGH_LEFT">
        <option value="1">{{
          $t("yourPhysicalInformation.HearingLeft")
        }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
      <select name="hearing-high-right" v-model.number="HEARING_HIGH_RIGHT">
        <option value="1">{{
          $t("yourPhysicalInformation.HearingRight")
        }}</option>
        <option value="2">{{
          $t("yourPhysicalInformation.NothingParticular")
        }}</option>
        <option value="3">{{
          $t("yourPhysicalInformation.AbnormalFinding")
        }}</option>
      </select>
    </div>

    <!-- 視力 -->
    <heading
      :title="$t('yourPhysicalInformation.EyeSightTitle')"
      class="title-adjust"
    />
    <div class="input-field--content">
      <label>{{ $t("yourPhysicalInformation.UncorrectedLabel") }}</label>
      <input
        type="number"
        v-model.number="WITHOUT_GLASSES_LEFT"
        min="0.0"
        max="9.99"
        v-validate="'between: 0.0, 9.99'"
        name="without-glasses-left"
        :placeholder="$t('yourPhysicalInformation.Left')"
      />
      <input
        type="number"
        v-model.number="WITHOUT_GLASSES_RIGHT"
        min="0.0"
        max="9.99"
        v-validate="'between: 0.0, 9.99'"
        name="without-glasses-right"
        :placeholder="$t('yourPhysicalInformation.Right')"
      />
      <div
        v-show="
          errors.has('without-glasses-left') ||
            errors.has('without-glasses-right')
        "
      ></div>
      <div
        class="invalid"
        v-show="errors.has('without-glasses-left')"
        align="center"
      >
        {{ $t("validation.between") }}
      </div>
      <div
        class="invalid"
        v-show="errors.has('without-glasses-right')"
        align="center"
      >
        {{ $t("validation.between") }}
      </div>
    </div>
    <div class="input-field--content">
      <label>
        {{ $t("yourPhysicalInformation.CorrectedLabel") }}
      </label>
      <input
        type="number"
        v-model.number="WITH_GLASSES_LEFT"
        min="0.0"
        max="9.99"
        v-validate="'between: 0.0, 9.99'"
        name="with-glasses-left"
        :placeholder="$t('yourPhysicalInformation.Left')"
      />
      <input
        type="number"
        v-model.number="WITH_GLASSES_RIGHT"
        min="0.0"
        max="9.99"
        v-validate="'between: 0.0, 9.99'"
        name="with-glasses-right"
        :placeholder="$t('yourPhysicalInformation.Right')"
      />
      <div
        v-show="
          errors.has('with-glasses-left') || errors.has('with-glasses-right')
        "
      ></div>
      <div
        class="invalid"
        v-show="errors.has('with-glasses-left')"
        align="center"
      >
        {{ $t("validation.between") }}
      </div>
      <div
        class="invalid"
        v-show="errors.has('with-glasses-right')"
        align="center"
      >
        {{ $t("validation.between") }}
      </div>
    </div>

    <!-- 病歴項目見出し -->
    <heading :title="$t('yourPhysicalInformation.aboutYourMedicalHistory')" />
    <!-- 病歴項目説明文 -->
    <p class="history--sentense">
      {{ $t("yourPhysicalInformation.pleaseSelectWithYesNo") }}
    </p>
    <!-- 病歴入力ボタン -->
    <disease-question
      v-for="(disease, index) in PAST_HISTORY"
      :key="index"
      :diseaseCode="disease"
      useIn="PAST_HISTORY"
      @toggleDisease="toggleDisease"
      @isChecked="setCountOfCheckedQuestion"
      class="disease-question"
    />

    <!-- next -->
    <next-button
      :label="$t('common.next')"
      :disabled="isDisable || NotCheckedHistory"
      @click="clickNextButton"
      class="button__next"
    />
  </div>
</template>

<script>
import Heading from "../../components/atoms/Heading";
import DiseaseQuestion from "../../components/molecules/AiDiseasePrediction/DiseaseQuestion";
import InputNum from "../../components/molecules/AiDiseasePrediction/InputNum";
import NextButton from "../../components/atoms/NextButton";

import isFuture from "../../plugin/validators/validator";

export default {
  data() {
    return {
      PAST_HISTORY: [
        "HCHK_APOP_PMH_YN",
        "HCHK_DIABML_PMH_YN",
        "HCHK_ETCDSE_PMH_YN",
        "HCHK_HDISE_PMH_YN",
        "HCHK_HPLPDM_PMH_YN",
        "HCHK_HPRTS_PMH_YN",
        "HCHK_PHSS_PMH_YN",
      ],
      // 病歴質問項目の初期状態数
      countOfCheckedQuestion: 0,
    };
  },
  components: {
    DiseaseQuestion,
    Heading,
    InputNum,
    NextButton,
  },
  computed: {
    T: {
      set(val) {
        this.$store.dispatch("aiPrediction/setT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getT"];
      },
    },
    DFAB_PTN_CD: {
      set(val) {
        this.$store.dispatch("aiPrediction/setDFAB_PTN_CD", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getDFAB_PTN_CD"];
      },
    },
    WAIST: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWAIST", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWAIST"];
      },
    },
    BMI: {
      set(val) {
        this.$store.dispatch("aiPrediction/setBMI", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getBMI"];
      },
    },
    BP_HIGH: {
      set(val) {
        this.$store.dispatch("aiPrediction/setBP_HIGH", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getBP_HIGH"];
      },
    },
    BP_LWST: {
      set(val) {
        this.$store.dispatch("aiPrediction/setBP_LWST", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getBP_LWST"];
      },
    },
    // 体重
    WEIGHT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWEIGHT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWEIGHT"];
      },
    },
    // 心電図
    ELECTROCARDIOGRAPHY: {
      set(val) {
        this.$store.dispatch("aiPrediction/setELECTROCARDIOGRAPHY", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getELECTROCARDIOGRAPHY"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setELECTROCARDIOGRAPHY", 1);
          return this.$store.getters["aiPrediction/getELECTROCARDIOGRAPHY"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    // 喀痰検査
    SPUTUM_EXAMINATION: {
      set(val) {
        this.$store.dispatch("aiPrediction/setSPUTUM_EXAMINATION", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getSPUTUM_EXAMINATION"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setSPUTUM_EXAMINATION", 1);
          return this.$store.getters["aiPrediction/getSPUTUM_EXAMINATION"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    // 聴力
    HEARING_LOW_LEFT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHEARING_LOW_LEFT", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getHEARING_LOW_LEFT"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setHEARING_LOW_LEFT", 1);
          return this.$store.getters["aiPrediction/getHEARING_LOW_LEFT"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    HEARING_LOW_RIGHT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHEARING_LOW_RIGHT", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getHEARING_LOW_RIGHT"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setHEARING_LOW_RIGHT", 1);
          return this.$store.getters["aiPrediction/getHEARING_LOW_RIGHT"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    HEARING_HIGH_LEFT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHEARING_HIGH_LEFT", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getHEARING_HIGH_LEFT"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setHEARING_HIGH_LEFT", 1);
          return this.$store.getters["aiPrediction/getHEARING_HIGH_LEFT"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    HEARING_HIGH_RIGHT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHEARING_HIGH_RIGHT", val);
      },
      get() {
        // 項目の初期化処理
        let value = this.$store.getters["aiPrediction/getHEARING_HIGH_RIGHT"];
        if (value === null) {
          // 何も選択していない場合
          this.$store.dispatch("aiPrediction/setHEARING_HIGH_RIGHT", 1);
          return this.$store.getters["aiPrediction/getHEARING_HIGH_RIGHT"];
        } else {
          // 選択時
          return value;
        }
      },
    },
    // 視力
    WITHOUT_GLASSES_LEFT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWITHOUT_GLASSES_LEFT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWITHOUT_GLASSES_LEFT"];
      },
    },
    WITHOUT_GLASSES_RIGHT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWITHOUT_GLASSES_RIGHT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWITHOUT_GLASSES_RIGHT"];
      },
    },
    WITH_GLASSES_LEFT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWITH_GLASSES_LEFT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWITH_GLASSES_LEFT"];
      },
    },
    WITH_GLASSES_RIGHT: {
      set(val) {
        this.$store.dispatch("aiPrediction/setWITH_GLASSES_RIGHT", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getWITH_GLASSES_RIGHT"];
      },
    },
    HCHK_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_APOP_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_APOP_PMH_YN"];
      },
    },
    HCHK_DIABML_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_DIABML_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_DIABML_PMH_YN"];
      },
    },
    HCHK_ETCDSE_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_ETCDSE_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_ETCDSE_PMH_YN"];
      },
    },
    HCHK_HDISE_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_HDISE_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_HDISE_PMH_YN"];
      },
    },
    HCHK_HPLPDM_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_HPLPDM_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_HPLPDM_PMH_YN"];
      },
    },
    HCHK_HPRTS_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_HPRTS_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_HPRTS_PMH_YN"];
      },
    },
    HCHK_PHSS_PMH_YN: {
      set(val) {
        this.$store.dispatch("aiPrediction/setHCHK_PHSS_PMH_YN", val);
      },
      get() {
        return this.$store.getters["aiPrediction/getHCHK_PHSS_PMH_YN"];
      },
    },
    // バリデーションチェック
    isDisable() {
      let bool = Object.keys(this.fields).some(
        (key) => this.fields[key].invalid
      );
      this.$store.dispatch("validations/setPhysicalInfo", bool);
      return bool;
    },
    // 病歴項目に全てチェックが行われているか確認
    NotCheckedHistory() {
      let bool;

      // チェックした個数が、全病歴質問項目を満たしているかどうか確認
      if (this.countOfCheckedQuestion === this.PAST_HISTORY.length) {
        bool = false;
      } else {
        bool = true;
      }
      return bool;
    },
  },
  methods: {
    toggleDisease(diseaseCode, bool) {
      this.$store.dispatch(`aiPrediction/set${diseaseCode}`, bool);
    },
    clickNextButton() {
      this.$emit("increment");
    },
    // チェックされた病歴質問項目を計算する
    setCountOfCheckedQuestion() {
      this.countOfCheckedQuestion += 1;
    },
  },
  created() {
    //スクロールの位置を初期化；　indexをページトップにする処理
    scrollTo(0, 0);
  },
};
</script>

<style scoped>
.input-filed--container {
  width: 100%;
  margin: 0 auto;
}

.input-field--content {
  display: grid;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
  grid-template-columns: 1fr 2fr 2fr;
  padding: 0 20px;
}
.input-field--content > select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 40px;
}
.input-field--content > input,
.input-field--content > select {
  border-radius: 5px;
  border: 1px solid #ced4da;
  background-color: #ffffff;
  height: 40px;
  font-size: calc(100% + 0.25vw);
}
.input-field--content > label {
  margin: 0;
  justify-self: start;
}

.input-field--content__date > input,
.input-field--content__select > select,
.input-field--content__waist > input,
.input-field--content__bmi > input,
.input-field--content__weight > input {
  grid-column: span 2;
}

/* 病歴項目説明文用 */
.history-sentense {
  text-align: left;
  font-size: 15px;
  font-weight: bold;
  padding: 20px;
}

.disease-question {
  padding: 0 20px;
}

.invalid {
  border-color: red;
  color: red;
}

.next-button {
  margin-top: 40px;
}
.form-control {
  border-radius: 5px;
  border: 1px solid #ced4da;
  padding: 5px;
  height: 30px;
  font-size: calc(100% + 0.25vw);
}
/*validation error 発生領域表示*/
.form-control.error {
  border-color: #e84444;
}
/*正常系*/
.form-control.pass {
  border-color: blue;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(232, 68, 68, 0.6);
}
/* 健康診断追加項目：大見出し調整 */
.title-adjust {
  margin-bottom: 40px;
}
</style>
